<template>
  <v-app dark class="main-app">
    <Navbar />
    <v-main class="bg">
      <router-view></router-view>
    </v-main>
    <Footer />
  </v-app>
</template>

<script>
// import components
import Navbar from "@/components/Navbar.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "App",
  components: {
    Navbar,
    Footer,
  },
  created() {
    if (this.isEmpty(this.getLocalStorage("favlist"))) {
      this.updateLocalStorage("favlist", []);
    }

    this.$store.commit("fillFavList", this.getLocalStorage("favlist") || []);
  },
  metaInfo: {
    titleTemplate: "حصن مسلم - %s",
  },
};
</script>
